import React from 'react'


function CourseOverview({ videoData }) {
  if (!videoData) {
    return (
      <div className="tw-p-[20px] course-overview">
        <div className="tw-bg-[#fff] tw-border-[1px] tw-border-solid tw-border-[#e0e0e0] tw-rounded-[8px] tw-overflow-hidden tw-m-0 course-overview-card">
          <div className="tw-p-[15px] content-main">
            <div className="tw-text-center">
              <div className="!tw-text-[var(--primary-color)] tw-w-[1.5em] tw-h-[1.5em] tw-inline-block tw-shrink-[0] tw-animate-[tw-spin_1s_linear_infinite] tw-rounded-full tw-border-[2px] tw-border-[currentColor] tw-border-r-[transparent] ui-spinner tw-text-brand-600" role="status">
                <span className="tw-sr-only">Loading...</span>
              </div>
              <p className="!tw-text-[var(--secondary-color)] tw-mt-2 tw-text-slate-500">Loading video details...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="course-overview tw-p-0">
      <div className="tw-bg-[#fff] tw-border-[1px] tw-border-solid tw-border-[#e0e0e0] tw-rounded-[8px] tw-overflow-hidden tw-m-0 course-overview-card">
        <div className="tw-bg-[#f8f9fa] tw-p-[8px_15px] tw-font-medium tw-border-b-[1px] tw-border-solid tw-border-b-[#e0e0e0] content-duration">
          <i className="fas fa-clock tw-me-2"></i>
          Duration: {videoData?.video_duration || '00:00'}
        </div>
        <div className="tw-p-[15px] content-main">
          <h2 className="tw-text-[20px] tw-font-semibold tw-text-[#333] tw-m-[0_0_10px_0] tw-block [transition:all_0.2s_ease] tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis content-title">
            {videoData?.video_title || videoData?.video_name || 'Untitled Video'}
          </h2>
          <div className="tw-text-[#666] tw-m-0 tw-p-0 tw-overflow-hidden tw-text-ellipsis [display:-webkit-box] [-webkit-line-clamp:2] [-webkit-box-orient:vertical] tw-text-[14px] content-description">
            {videoData?.video_description || 'No description available'}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CourseOverview
